// extracted by mini-css-extract-plugin
export var Grid = "Grid-module--Grid--IJYXO";
export var GridColumn = "Grid-module--GridColumn--lIsFF";
export var GridRow = "Grid-module--GridRow--Zn5CB";
export var GridRow__inner = "Grid-module--GridRow__inner--IJpb2";
export var aniSpin = "Grid-module--ani-spin--HLmZZ";